import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PublicHeader } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import Certificate from "@/components/Certificate";
import { CheckCircle2, ArrowLeft, Printer } from "lucide-react";

export default function ValidationResult() {
  const navigate = useNavigate();
  const [result, setResult] = useState(null);

  useEffect(() => {
    const raw = sessionStorage.getItem("certiseal_result");
    if (!raw) {
      navigate("/");
      return;
    }
    setResult(JSON.parse(raw));
  }, [navigate]);

  if (!result) return null;

  return (
    <div className="min-h-screen bg-slate-50">
      <PublicHeader />
      <div className="w-full max-w-5xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900 mb-8" data-testid="back-to-home">
          <ArrowLeft className="w-4 h-4" /> Back to verification
        </Link>

        <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center">
              <CheckCircle2 className="w-6 h-6 text-emerald-600" strokeWidth={2.5} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] font-semibold text-emerald-700">Credential Authenticated</div>
              <div className="font-display font-extrabold text-xl text-slate-900" data-testid="result-status">Verified by CertiSeal</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right">
              <div className="text-xs uppercase tracking-widest font-semibold text-slate-500">Voucher uses left</div>
              <div className="font-display font-extrabold text-2xl text-slate-900" data-testid="voucher-uses-remaining">{result.voucher_uses_remaining}</div>
            </div>
            <Button variant="outline" onClick={() => window.print()} data-testid="print-btn">
              <Printer className="w-4 h-4 mr-2" /> Print
            </Button>
          </div>
        </div>

        <Certificate certificate={result.certificate} institution={result.institution} animate />
      </div>
    </div>
  );
}
